// Lazy load client config
(async function () {
    const { initSentryClient } = await import('./utils/sentry');
    initSentryClient();
})();
